import * as React from 'react';
// mui
import { Card, CardHeader } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
// redux
import { useSelector } from 'react-redux';
import { selectAllTasks } from '../../store/selectors/taskSelectors';
import { selectAllRecurringTasks } from '../../store/selectors/recuringTaskSelectors';
// types
import Task from '../../interfaces/Task.interface';
import RecurringTask from '../../interfaces/RecurringTask.interface';

export default function EnergyChart() {
  const localTasks: Task[] = useSelector(selectAllTasks());
  const localRecurringTasks: RecurringTask[] = useSelector(selectAllRecurringTasks());

  const [ chartData, setChartData ] = React.useState<number[]>([]);

  React.useEffect(() => {
    const tempData = [0,0,0,0,0];

    for (let i = 0; i < localTasks.length; i += 1) {
      tempData[localTasks[i].energy - 1] += 1;
    }

    for (let i = 0; i < localRecurringTasks.length; i += 1) {
      tempData[localRecurringTasks[i].energy - 1] += 1;
    }

    setChartData(tempData);
  }, [])
  
  return (
    <Card sx={{ p: 1 }} variant="outlined">
      <CardHeader
        subheader={"Distribution of Energy Levels"}
      />
      <BarChart
        series={[
          { data: chartData },
        ]}
        height={290}
        colors={['#556cd6']}
        xAxis={[{ data: ['Effortless', 'Low', 'Medium', 'Normal', 'High'], scaleType: 'band' }]}
        margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
      />
    </Card>
  );
}